import { whyChooseUs, packagingOptions } from "../../../mocks/products";

export default function WhyChooseUs() {
  return (
    <>
      {/* Why Choose Us */}
      <section className="py-20 md:py-24 bg-[#1B4332]">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="text-center mb-14">
            <span className="inline-block text-[#C9A227] text-xs font-bold tracking-widest uppercase border border-[#C9A227] px-3 py-1 rounded-full mb-4">
              Our Advantage
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              Why Choose Pandit Export?
            </h2>
            <p className="text-white/60 text-base max-w-xl mx-auto">
              We go beyond just exporting products — we build trust, deliver value, and ensure your success.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
            {whyChooseUs.map((item, i) => (
              <div
                key={i}
                className="group p-6 rounded-2xl border border-white/10 hover:border-[#C9A227]/50 bg-white/5 hover:bg-white/10 transition-all duration-300 text-center cursor-default"
              >
                <div className="w-14 h-14 flex items-center justify-center rounded-full bg-[#C9A227]/15 text-[#C9A227] mx-auto mb-4 group-hover:bg-[#C9A227] group-hover:text-white transition-all duration-300">
                  <span className="text-2xl">
                    <i className={item.icon}></i>
                  </span>
                </div>
                <h3 className="text-sm font-bold text-white mb-2">{item.title}</h3>
                <p className="text-xs text-white/55 leading-relaxed">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Packaging Section */}
      <section className="py-20 md:py-24 bg-[#FFFBF0]">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="flex flex-col lg:flex-row gap-14 items-center">
            {/* Left */}
            <div className="w-full lg:w-[45%]">
              <span className="inline-block text-[#C9A227] text-xs font-bold tracking-widest uppercase border border-[#C9A227] px-3 py-1 rounded-full mb-4">
                Packaging Solutions
              </span>
              <h2 className="text-3xl md:text-4xl font-bold text-[#1B4332] mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>
                Safe, Reliable &amp; Customized Packaging
              </h2>
              <p className="text-gray-500 text-base leading-relaxed mb-8">
                We offer a variety of export-grade packaging solutions to protect your products during transit. From eco-friendly jute bags to custom-branded private label packaging — we've got you covered.
              </p>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {packagingOptions.map((pkg, i) => (
                  <div
                    key={i}
                    className="flex items-start gap-3 p-4 bg-white rounded-xl border border-[#C9A227]/20 hover:border-[#C9A227] transition-all duration-200 cursor-default group"
                  >
                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-[#D8F3DC] text-[#2D6A4F] flex-shrink-0 group-hover:bg-[#2D6A4F] group-hover:text-white transition-all duration-200">
                      <span className="text-xl">
                        <i className={pkg.icon}></i>
                      </span>
                    </div>
                    <div>
                      <h4 className="text-sm font-bold text-[#1B4332]">{pkg.title}</h4>
                      <p className="text-xs text-gray-400 mt-0.5">{pkg.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Right - Image */}
            <div className="w-full lg:w-[52%]">
              <div className="relative rounded-2xl overflow-hidden">
                <img
                  src="https://public.readdy.ai/ai/img_res/fa022d2bc8273792053593d6c6d2b2bb.jpg"
                  alt="Packaging Solutions"
                  className="w-full h-[360px] object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#1B4332]/50 to-transparent"></div>
                <div className="absolute bottom-6 left-6 right-6">
                  <div className="bg-white/95 rounded-xl p-4 flex items-center gap-3">
                    <span className="w-10 h-10 flex items-center justify-center bg-[#C9A227] rounded-lg text-white">
                      <i className="ri-shield-check-line text-xl"></i>
                    </span>
                    <div>
                      <p className="text-sm font-bold text-[#1B4332]">Export-Grade Standards</p>
                      <p className="text-xs text-gray-400">All packaging meets international transit requirements</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
